import { createContext, ReactNode, useEffect, useReducer } from "react";
import { AppAction, AppState, getCachedAppState, initialState, startReducer } from "./startReducer";

export const AppContext = createContext<{
    state: AppState;
    dispatch: React.Dispatch<AppAction>;
}>({
    state: initialState,
    dispatch: () => null
});

declare const window: any;

export const AppProvider = (props: { children: ReactNode }) => {
    const firstAppState = getCachedAppState()
    const [appState, dispatch] = useReducer(startReducer, firstAppState);
    const isLandscape = () => window.matchMedia('(orientation:landscape)').matches
    useEffect(() => {
        dispatch({ type: "setIsLandscape", isLandscape: isLandscape() })
        const onWindowResize = () => {
            clearTimeout(window.resizeLag)
            window.resizeLag = setTimeout(() => {
                delete window.resizeLag
                dispatch({ type: "setIsLandscape", isLandscape: isLandscape() })
            }, 200)
        }
        onWindowResize();
        window.addEventListener('resize', onWindowResize);
    }, []);

    return (
        <AppContext.Provider value={{ state: appState, dispatch }}>
            {props.children}
        </AppContext.Provider>
    );
};